function Footer() {
  return (
    <>
      <div className="footer-credit" id="footer-credit">
        Developed by my ❤️:
        <a
          href="https://github.com/fionajannat"
          target="_blank"
          rel="noreferrer"
        >
          Fiona E Jannat
        </a>
      </div>
    </>
  );
}
export default Footer;
